import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { connectNewCasinoHome } from './NewCasinoHome.connect'
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonHeader,
  IonIcon,
} from '@ionic/react'
import './casinoHome.css'
import { chevronBack, chevronForward } from 'ionicons/icons'
import { useHistory } from 'react-router'
import { setLoginNew } from '../../store/LoginNew/loginNew.slice'
import { requestSlotsGamesID } from '../../store/slotsGames/slotsGames.thunks'

const ProviderImage = ({ provider, isOriginal = false }) => {
  const auth = useSelector((state) => state.auth)

  const dispatch = useDispatch()

  const onOpenGame = useCallback(
    (item) => {
      if (auth) {
        if (isOriginal) {
          history.push(`/casino_live/${item?.ID}/${item?.Type}`)
        } else {
          dispatch(requestSlotsGamesID(item?.id, item?.aggType))
          history.push(`/live_casino_slot/${item?.id}`)
        }
      } else {
        dispatch(setLoginNew(true))
      }
    },
    [auth]
  )

  const history = useHistory()

  const [isLoaded, setIsLoaded] = useState(false)

  if (isOriginal) {
    return (
      <img
        className={`providerImage ${isLoaded ? '' : 'notLoadedProviderImage'}`}
        src={`${provider?.ImageURL}`}
        alt={provider?.en}
        onClick={() => onOpenGame(provider)}
        onLoad={() => setIsLoaded(true)}
      />
    )
  }
  return (
    <img
      className={`providerImage ${isLoaded ? '' : 'notLoadedProviderImage'}`}
      src={`${
        provider?.imageUrl?.length > 0
          ? provider?.imageUrl
          : `https://luckmedia.link/${provider?.id}/thumb_1_1.webp`
      }`}
      alt={provider?.name}
      onClick={() => onOpenGame(provider)}
      onLoad={() => setIsLoaded(true)}
    />
  )
}

const CasinoHome = ({ actions }) => {
  const { providersOnHome, providerWiseData } = useSelector(
    (state) => state.casinoHome
  )

  const categoryContainerRef = useRef(null)

  const providerRefs = useRef([])

  const [selectedProvider, setSelectedProvider] = useState({
    name: 'Originals',
    id: 0,
  })

  useEffect(() => {
    if (!providersOnHome.data) {
      actions.providersOnHome(0)
    }
  }, [])

  // Modify the scroll function
  const scrollToProvider = (index) => {
    if (providerRefs.current[index] && categoryContainerRef.current) {
      const container = categoryContainerRef.current
      const element = providerRefs.current[index]

      container.scrollTo({
        left: element.offsetLeft - container.offsetLeft,
        behavior: 'smooth',
      })
    }
  }

  const promotions = useSelector((state) => state.promotions)

  const handleProviderClick = (provider, index) => {
    setSelectedProvider(provider)
    if (!providerWiseData?.data[provider.name]) {
      actions.providersOnHome(provider._id, provider.name)
    }
    if (providerRefs.current[index]) {
      scrollToProvider(index)
    }
  }

  const handleScroll = (direction) => {
    if (categoryContainerRef.current) {
      categoryContainerRef.current.scrollTo({
        left: categoryContainerRef.current.scrollLeft + direction * 100,
        behavior: 'smooth',
      })
    }
  }

  const sortedOrginalGames = useMemo(() => {
    if (promotions?.trendingGames) {
      return [...(promotions?.trendingGames || [])]?.sort((a, b) => {
        return a.index - b.index
      })
    }
    return []
  }, [promotions?.trendingGames])

  const providers = useMemo(() => {
    return [...(providersOnHome?.data || [])]?.filter((item) => item.status)
  }, [providersOnHome?.data])

  return (
    <div className="mainContainer">
      <IonCard>
        <div className="providerHeader">
          <IonCardHeader
            className="providerHeaderScroll"
            style={{
              paddingTop: '10px',
              paddingBottom: '0px',
              paddingLeft: '6px',
              paddingRight: '6px',
            }}
          >
            <div className="providerCategories" ref={categoryContainerRef}>
              <div
                className={`providerCategoryButton ${
                  selectedProvider?.name === 'Originals' ? 'selected' : ''
                }`}
                onClick={() => handleProviderClick({ name: 'Originals' }, 0)}
                ref={(el) => (providerRefs.current[0] = el)}
              >
                <span>Originals</span>
                {selectedProvider?.name === 'Originals' && (
                  <div className=" bottomLineProviderCategory"> </div>
                )}
              </div>
              {providers?.map((item, index) => (
                <div
                  key={item.name}
                  className={`providerCategoryButton ${
                    selectedProvider?.name === item.name ? 'selected' : ''
                  }`}
                  onClick={() => handleProviderClick(item, index + 1)}
                  ref={(el) => (providerRefs.current[index + 1] = el)}
                >
                  <span>{item.name}</span>
                  {selectedProvider?.name === item.name && (
                    <div className=" bottomLineProviderCategory"> </div>
                  )}
                </div>
              ))}
            </div>
          </IonCardHeader>
          <div className="providerHeaderRight">
            <button
              onClick={() => handleScroll(-1)}
              style={{ background: 'transparent', padding: '0px' }}
            >
              <IonIcon icon={chevronBack} className="providerHeaderIcon" />
            </button>
            <button
              onClick={() => handleScroll(1)}
              style={{ background: 'transparent', padding: '0px' }}
            >
              <IonIcon icon={chevronForward} className="providerHeaderIcon" />
            </button>
          </div>
        </div>

        <IonCardContent className="providerWiseGamesContainerMain">
          <div className="providerWiseGames">
            {selectedProvider?.name === 'Originals'
              ? sortedOrginalGames?.map((item) => {
                  return (
                    <ProviderImage
                      key={item._id}
                      provider={item}
                      isOriginal={true}
                    />
                  )
                })
              : providerWiseData?.data[selectedProvider?.name]?.data?.map(
                  (item) => {
                    return <ProviderImage key={item._id} provider={item} />
                  }
                )}
          </div>
        </IonCardContent>
      </IonCard>
    </div>
  )
}

export default connectNewCasinoHome()(CasinoHome)
